export { default as CoreModelPage } from './component';
